/**
 * Parse decrypted API text safely (avoids "Unexpected end of JSON input").
 */
export const parsePaymentApiResponse = (raw) => {
  if (raw == null || String(raw).trim() === "") {
    throw new Error("Empty response from server");
  }

  try {
    const parsed = JSON.parse(raw);
    if (typeof parsed === "string" && parsed.trim().startsWith("{")) {
      return JSON.parse(parsed);
    }
    return parsed;
  } catch {
    throw new Error("Invalid response from server");
  }
};

export const isTransferSuccess = (data) => {
  if (!data || typeof data !== "object") return false;

  const statusCode = String(data.statusCode ?? "");
  if (statusCode !== "200") return false;

  if (data.subCode != null && String(data.subCode) !== "200") return false;

  if (String(data.status ?? "").toUpperCase() === "ERROR") return false;

  return true;
};

export const getTransferErrorMessage = (data) => {
  if (!data || typeof data !== "object") return "";
  const msg =
    data.secondaryMsg ?? data.secondaryMessage ?? data.message ?? data.succAndFailMsg;
  return msg != null ? String(msg).trim() : "";
};
